import { registerPlugin } from '@capacitor/core';
const LocalizationSettings = registerPlugin('LocalizationSettings', {
    web: () => import('./web').then((m) => new m.LocalizationSettingsWeb()),
});
export * from './definitions';
export { LocalizationSettings };
//# sourceMappingURL=index.js.map